/**
 * Use this class to track the status of async function calls
 *
 * TODO: add support for multiple simultaneous calls
 */
class AsyncStatus {

  constructor() {
    this.count = 0;
    this.reset();
  }

  reset() {
    this.promise = new Promise(r => r());
    this.pending = false;
    this.completed = false;
    this.resolved = false;
    this.rejected = false;
    this.error = null;
  }

  track(fn) {
    this.reset();
    this.pending = true;
    const p = this;
    this.promise = fn.apply(this, arguments)
      .then(data => {
        p.resolved = true;
        p.rejected = false;
        p.error = null;
        return data;
      })
      .catch(e => {
        p.resolved = false;
        p.rejected = true;
        p.error = e;
        throw e;
      })
      .finally(() => {
        p.completed = true;
        p.pending = false;
        p.count = p.count + 1;
      });
    return this.promise;
  }

}


export default AsyncStatus;
